import React from 'react'

export default function About() {
  return (
    <div className='mt-24'>About</div>
  )
}
